import { first } from 'rxjs/operators';
import { AssignmentProposalServiceFactory, AssignmentProposalService } from './../assignment-proposal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CartService } from './../cart.service';
import { Role } from './../user.model';
import { AuthService } from './../auth.service';
import { Observable } from 'rxjs';
import { Itinerary } from './../itineray.model';
import { ItineraryService } from './../itinerary.service';
import { Component, OnInit, Input } from '@angular/core';
import { AssignmentProposal } from '../assignment-proposal.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-itinerary-list',
  templateUrl: './itinerary-list.component.html',
  styleUrls: ['./itinerary-list.component.css']
})
export class ItineraryListComponent implements OnInit {

  itineraries$: Observable<Itinerary[]>;

  itinerariesPendingCurrentUserAssignmentProposals: AssignmentProposal[];

  archived = false;

  constructor(private itineraryService: ItineraryService, private authService: AuthService, private cartService: CartService, private router: Router, private assignmentProposalServiceFactory: AssignmentProposalServiceFactory, private snackBar: MatSnackBar,) {

  }

  async ngOnInit() {
    this.list();
    if (this.authService.user.hasRole(Role.ADMIN) == false) {
      this.itinerariesPendingCurrentUserAssignmentProposals = await this.assignmentProposalServiceFactory.create(null).listCollectionGroupPendingForUser(this.authService.user).pipe(first()).toPromise();
    }
  }

  async list() {
    if (this.authService.user.hasRole(Role.ADMIN)) {
      this.itineraries$ = this.itineraryService.list((ref => ref.where('archived', '==', this.archived)));
    } else {
      this.itineraries$ = this.itineraryService.listForAssignee(this.authService.user, this.archived);
    }
  }

  isAdmin() {
    return this.authService.user && this.authService.user.hasRole(Role.ADMIN);
  }

  async addItinerary() {
    const title = prompt("Che titolo vuoi dare al nuovo itinerario?");
    const cartId = prompt("Quale carrello vuoi associare a questo itinerario? Inserisci il cart_id");
    if (!cartId || cartId.trim() === "") {
      alert("E' necessario specificare un cart_id valido");
      return;
    }

    const exists = await this.cartService.exists(cartId).pipe(first()).toPromise();
    if (!exists) {
      alert("Cart with id " + cartId + " does not exists");
      return;
    }

    if (!confirm("L'itinerario sarà creato come itinerario di test.\nPotrai comunque sempre modificare il flag dalle impostazioni dell'itinerario.")) {
      return;
    }

    const itinerary = new Itinerary({
      title: title.trim(),
      cart: this.cartService.ref(cartId),
      status: "TODO",
      test: true,
      archived: false
    });
    await this.itineraryService.create(itinerary);

    this.router.navigate(['/itineraries', itinerary.id]);
  }

  async archive(itinerary: Itinerary) {
    try {
      await this.itineraryService.update({ id: itinerary.id, archived: true });
      this.snackBar
        .open("Itinerario archiviato.", null, {
          duration: 4000
        });
      this.list();
    } catch (e) {
      console.error(e);
      this.snackBar
        .open("Purtroppo si è verificato un errore.", null, {
          duration: 4000
        });
    }
  }

  async unarchive(itinerary: Itinerary) {
    try {
      await this.itineraryService.update({ id: itinerary.id, archived: false });
      this.snackBar
        .open("Itinerario spostato tra quelli In Arrivo.", null, {
          duration: 4000
        });
      this.list();
    } catch (e) {
      console.error(e);
      this.snackBar
        .open("Purtroppo si è verificato un errore.", null, {
          duration: 4000
        });
    }
  }

  async delete(itinerary: Itinerary) {
    if (!confirm("Sei veramente sicuro di voler eliminare questo itinerario?\nNon è possibile annullare l'operazione, l'itinerario sarà perso per sempre!\nRicorda che in questo caso la fee eventualmente dovuta al travel advisor incaricato non sarà conteggiata tra i suoi corrispettivi.")) return;
    try {
      await this.itineraryService.remove({ id: itinerary.id });
      this.snackBar
        .open("Itinerario eliminato.", null, {
          duration: 4000
        });
      this.list();
    } catch (e) {
      console.error(e);
      this.snackBar
        .open("Purtroppo si è verificato un errore.", null, {
          duration: 4000
        });
    }
  }

}
